import React, { useEffect, useState } from "react";

export default function MarginTifModal({ open, onClose, initialValue, onConfirm }) {
  const [draft, setDraft] = useState(initialValue || "GTC");

  useEffect(() => {
    if (open) setDraft(initialValue || "GTC");
  }, [open, initialValue]);

  if (!open) return null;

  const options = [
    {
      id: "GTC",
      title: "GTC (Good Till Cancelled)",
      desc: "Remain in effect until fully filled or cancelled",
    },
    {
      id: "IOC",
      title: "IOC (Immediate or Cancel)",
      desc: "Fill all or part of the order immediately and cancel the remaining unfilled part",
    },
    {
      id: "FOK",
      title: "FOK (Fill or Kill)",
      desc: "Must be filled immediately, otherwise it will be cancelled",
    },
  ];

  return (
    <div className="agcx-ft-modal-root" role="dialog" aria-modal="true" aria-labelledby="agcx-ft-tif-title">
      <button type="button" className="agcx-ft-modal-backdrop" aria-label="Close" onClick={onClose} />
      <div className="agcx-ft-modal-panel agcx-ft-modal-panel--tif">
        <div className="agcx-ft-modal-head border-0 pb-1">
          <h2 id="agcx-ft-tif-title" className="agcx-ft-modal-title">
            TIF
          </h2>
          <button type="button" className="agcx-ft-modal-close" aria-label="Close" onClick={onClose}>
            <i className="ri-close-line"></i>
          </button>

        </div>
        <div className="agcx-ft-modal-body pt-3">
          <div className="agcx-ft-tif-list d-flex flex-column gap-3">
            {options.map((opt) => {
              const selected = draft === opt.id;
              return (
                <button
                  key={opt.id}
                  type="button"
                  className={`agcx-ft-tif-card d-flex align-items-center justify-content-between text-start${selected ? " is-selected" : ""}`}
                  onClick={() => {
                    setDraft(opt.id);
                    onConfirm?.(opt.id);
                    onClose?.();
                  }}
                >
                  <div className="agcx-ft-tif-card__content">
                    <div className="agcx-ft-tif-card__title">{opt.title}</div>
                    <div className="agcx-ft-tif-card__desc">{opt.desc}</div>
                  </div>
                  <div className="agcx-ft-tif-card__check">
                    {selected ? (
                      <div className="agcx-ft-tif-check-box is-checked">
                        <i className="ri-check-line"></i>
                      </div>
                    ) : (
                      <div className="agcx-ft-tif-check-box"></div>
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
